import React, { useState } from 'react';

import {
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { Navigate } from 'react-router-dom';

import MainBar from '../components/mainbar';
import { useAuth } from '../utils/AuthContext';

export const LoginAdmin = () => {
  const { status, login_email, error, setError } = useAuth();

  const [inputs, setInputs] = useState<string>('');

  const handleSubmit = () => {
    // console.log('inputs', inputs);
    if (inputs == '') {
      setError('尚未輸入登入碼');
      return;
    }
    login_email(inputs);
  };

  if (status === 'logged_in') {
    return <Navigate to='/' replace />;
  }

  return (
    <>
      <MainBar />
      <Stack sx={{ width: '100vw', alignItems: 'center', mt: 10, flexGrow: 1 }} spacing={2}>
        <Typography variant='h4' color='primary'>登入蔣重點醫學</Typography>
        <TextField
          id='outlined-basic'
          label='Code'
          variant='outlined'
          sx={{ width: 300, maxWidth: 500 }}
          value={inputs}
          // helperText='內部人員專用'
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setInputs(event.target.value);
          }}
        />
        <Button
          variant='contained'
          sx={{ width: 300 }}
          onClick={handleSubmit}
          loading={status === 'loading'}
        >
          Login
        </Button>
        {error && <Typography variant='body1' sx={{ color: 'red' }}>{error}</Typography>}
      </Stack>
    </>
  )
}

const Login = () => {
  const { status, login_google, error } = useAuth();

  if (status === 'logged_in') {
    return <Navigate to='/' replace />;
  }

  return (
    <>
      <MainBar />
      <Stack sx={{ width: '100vw', alignItems: 'center', mt: 10, flexGrow: 1 }} spacing={2}>
        <Typography variant='h4' color='primary'>登入蔣重點醫學</Typography>
        <Button
          onClick={login_google}
          variant='outlined'
          sx={{ width: 300 }}
          loading={status === 'loading'}
        >
          使用 Google 登入
        </Button>
        {error && <Typography variant='body1' sx={{ color: 'red' }}>{error}</Typography>}
      </Stack>
    </>
  )
}

export default Login;